import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/angular16/33 angularFormData Validadores asíncronos/src/app/app.component.ts